import {initElements} from "../define/shared";

export default function initWysiwygContent() {
    initElements(".wysiwyg-content", content => {
        const readMoreBtn = content.querySelector(".readMore");
        const hiddenContent = content.querySelector(".hiddenContent");

        if (!readMoreBtn) {
            return;
        }

        readMoreBtn.addEventListener("click", () => {
            hiddenContent.classList.add("is--open");
            readMoreBtn.remove()
        });
    });
}
